module.exports = __webpack_public_path__ + "whitehop.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitehop.png
// module id = 891
// module chunks = 0